import { Controller } from '@hotwired/stimulus';

/**
 * Toggle Controller
 *
 * Simple toggle for showing/hiding content with accessibility support.
 * Used by the contractor portal upload form to reveal the optional comment textarea.
 *
 * Targets:
 * - content: The element to show/hide
 * - trigger: The button/link that toggles visibility
 *
 * Values:
 * - open: Whether the content is currently visible (default: false)
 *
 * @example
 * <div data-controller="toggle">
 *   <button data-toggle-target="trigger"
 *           data-action="toggle#toggle"
 *           aria-expanded="false"
 *           aria-controls="comment-section">
 *     Ajouter un commentaire (optionnel)
 *   </button>
 *   <div id="comment-section"
 *        data-toggle-target="content"
 *        class="hidden">
 *     Hidden content
 *   </div>
 * </div>
 */
export default class extends Controller {
  static targets = ['content', 'trigger', 'chevron'];

  static values = {
    open: { type: Boolean, default: false },
  };

  toggle(event) {
    event?.preventDefault();
    this.openValue = !this.openValue;
  }

  open() {
    this.openValue = true;
  }

  close() {
    this.openValue = false;
  }

  openValueChanged(isOpen) {
    this.contentTarget.classList.toggle('hidden', !isOpen);

    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute('aria-expanded', isOpen.toString());
    }

    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle('rotate-90', isOpen);
    }

    this.dispatch(isOpen ? 'opened' : 'closed');
  }
}
